import { AvailableDateResponseDto, ReservationRequestDto } from "@/api/generated/generatedTypes";

export interface Location {
  id: number;
  name: string;
}

export interface StagingGroup {
  id: string;
  selectedDate: string | null;
  selectedLocationId: number | null;
  stagedRequests: ReservationRequestDto[];
}

export interface StagingGroupCardProps {
  stagingGroup: StagingGroup;
  availableDates: AvailableDateResponseDto[];
  locations: Location[];
  isSelected: boolean;
  onSelect: () => void;
  onUpdateDate: (date: string) => void;
  onUpdateLocation: (locationId: number) => void;
  onRemoveRequest: (requestId: number) => void;
  onSave: () => void;
  onCreate: () => void;
  onDelete: () => void;
}

export const formatTime = (time: Date | string): string => {
  const timeString = typeof time === "string" ? time : time.toISOString();
  return new Date(timeString).toLocaleString();
};
